import React, { useContext, useEffect, useState } from "react";
import { Route, Switch, useParams } from "react-router";
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useHistory, useLocation,} from "react-router-dom";
import styled from "styled-components";
import { APIContext } from "../../contexts/APIContext";
import { DataContext } from "../../contexts/DataContext";

const GAME_BY_ID = gql`
  query GameByID($id: String) {
    gameById(id: $id) {
      _id
      oval_ID
      time
      description
      date
      home_team_kit
      away_team_kit
      stadium {
        opta_name
        name
      }
      competition {
        oval_ID
        name
        competition_type
        badge
        secondary_badge
        flag_path
        fighter_path
        fighter_full_path
        categories
      }
      home_scorers
      away_scorers
      home_penalties
      away_penalties
      home_player_stats
      away_player_stats
      home_player_ciq_stats
      away_player_ciq_stats
      home_team_stats
      away_team_stats
      home_fighter {
        _id
        first_name
        last_name
        short_name
        image
        image_2
        stories
        shorts_colour
        nationality {
          code
        }
      }
      away_fighter {
        _id
        first_name
        last_name
        short_name
        image
        image_2
        stories
        shorts_colour
        nationality {
          code
        }
      }
      live_data
      home_phase
      away_phase
      metres_gained
      number_of_rounds
      round_minutes
      winner
      winnerby
      completed
      gold_fight
      title
      season {
        _id
        oval_ID
      }
      commentators
      mc
      referee {
        _id
        first_name
        last_name
      }
      judges {
        _id
        first_name
        last_name
      }
      home_sets
      away_sets
      ciq_stats
    }
  }
`;

const GAME_SUBSCRIPTION = gql`
  subscription GameUpdated($id: String!) {
    gameUpdated(_id: $id) {
      _id
      home_team_kit
      away_team_kit
      live_data
      home_scorers
      away_scorers
      home_penalties
      away_penalties
      home_formation
      away_formation
      home_player_stats
      away_player_stats
      home_player_ciq_stats
      away_player_ciq_stats
      home_team_stats
      away_team_stats
      season {
        _id
        oval_ID
      }
      commentators
      mc
      home_phase
      away_phase
      metres_gained
      home_player_stats
      away_player_stats
      home_player_ciq_stats
      away_player_ciq_stats
      home_team_stats
      away_team_stats
      home_sets
      away_sets
      number_of_rounds
      round_minutes
      gold_fight
      title
      ciq_stats
    }
  }
`;

const Main = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: space-around;
`;

const Button = styled.div`
  display: flex;
  width: 45%;
  height: 80%;
  justify-content: center;
  align-items: center;
  background-color: #202731;
  border-radius: 4px;
  margin: 1em;
  font-size: 20px;
`;
export default function CommsSelect() {
  let { gameID } = useParams();
  const [getGame, { data }] = useLazyQuery(GAME_BY_ID);
  const [game, setGame] = useState();
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    if (gameID) {
      getGame({ variables: { id: gameID } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameID]);

  useEffect(() => {
    if (data) {
      setGame(data.gameById);
    }
  }, [data]);
    if (!game) return <div>Loading</div>;

  return (
    game && ( 
    <div className="flex md:flex-row flex-col w-dvw h-dvh justify-start gap-5 py-5 items-center bg-surface-low rounded">
      <button className="md:w-[30%] md:h-[100%] w-[90%] h-[25%] bg-surface hover:border-[#76ffb0] hover:border-2 text-primary"
       type="button"
       onClick={() => {
          history.push({
            pathname: "/comms/" + gameID + "/0",
          });
        }}
      >
        {game?.commentators?.[0]?.first_name} {game?.commentators?.[0]?.last_name}
      </button>
      <button className="md:w-[30%] md:h-[100%] w-[90%] h-[25%] bg-surface hover:border-[#76ffb0] hover:border-2 text-primary"
       type="button" 
        onClick={() => {
          history.push({
            pathname: "/comms/" + gameID + "/1",
          });
        }}
      >
        {game?.commentators?.[1]?.first_name} {game?.commentators?.[1]?.last_name}
      </button>
        <button className="md:w-[30%] md:h-[100%] w-[90%] h-[25%] bg-surface hover:border-[#76ffb0] hover:border-2 text-primary"
        type="button"
        onClick={() => {
          history.push({
            pathname: "/comms/" + gameID + "/2",
          });
        }}
      >
        {game?.commentators?.[2]?.first_name} {game?.commentators?.[2]?.last_name}
      </button>
    </div>
  ));
}

